var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XRPTxContainer',{attrs:{"tx":_vm.tx}},[_c('div',{staticClass:"offer"},[_vm._v(" Offer: "+_vm._s(_vm._f("ellipsis")(_vm.offer,10))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }